module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#proofread",
      toString: function () {
        return this.url;
      }
    }